const productData = [
    {
      id: 1,
      name: "Box 5g Speed Pro",
      image:"https://i.ibb.co/1RF1Gfq/favicon.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      appLink: "https://gitlab.com/mtkdev1/dextereskalarte/-/raw/main/app.boxvpntunnel.dexbuild-DexBuild-V2-release.apk" 
       },
    {
      id: 2,
      name: "180G HIGH SPEED PRO",
      image:"https://i.ibb.co/QvTNHKnw/ic-app-icon.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY", "SSH", "SLOWDNS"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/mtkdev1/dextereskalarte/-/raw/main/box-180g.apk"
   // },
    //{
   //   id: 3,
   //   name: "IPHONE SPEED PRO",
    //  image:
    //    "https://i.ibb.co/z7pfLQc/icon-icon.png",
   //   productType: "openBackHeadphones",
   //   description: ["OVPN", "UDP", "V2RAY", "SSH", "SLOWDNS"],
   //   rating: 5,
    //  timeLeft: 24,
   //   appLink: "https://panelvip.co.uk/iphone.apk"

    }
    // {
    //   id: 4,
    //   name: "SECURE TUNNEL",
    //   image:
    //     "https://i.postimg.cc/wMW7LWFC/keyhole-958517.png",
    //   productType: "openBackHeadphones",
    //   description: ["OVPN", "UDP", "V2RAY"],
    //   rating: 5,
    //   timeLeft: 24,
    //   appLink: "https://tinyurl.com/StarLinkVPNnew-Apk"
    // }
  ];
  export default productData;
